// Copyright 2025, University of Maryland, All Rights Reserved
/**
 * cm-coding: ConnectorsManager owns the complete System Connectors content,
 * including its heading, because it is also rendered independently in tests.
 * This page supplies only the shared administration background and container;
 * adding another heading here would show users two titles for the same screen.
 */
import { ConnectorsManager } from '../components/ConnectorsManager';

export default function ConnectorsPage() {
  return (
    <div className="min-h-full bg-slate-50 text-slate-900">
      <div className="mx-auto max-w-[1280px] px-6 pt-9 pb-16 sm:px-10">
        <ConnectorsManager />
      </div>
    </div>
  );
}
